module.exports = __webpack_public_path__ + "img/share-05.412a5330.svg";